import { render, staticRenderFns } from "./verifyComponent.vue?vue&type=template&id=b4c644dc&scoped=true"
import script from "./verifyComponent.vue?vue&type=script&lang=js"
export * from "./verifyComponent.vue?vue&type=script&lang=js"
import style0 from "./verifyComponent.vue?vue&type=style&index=0&id=b4c644dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c644dc",
  null
  
)

export default component.exports